import {toastr} from "react-redux-toastr";
import * as actionTypes from "./actionTypes";
import {appLoading, appSuccess, appError} from "./appActions";
import {claimEmail, postClaim, getClaims} from "../../api/claimApi";

export const getClaimsSuccess = (claims) => ({
  type: actionTypes.GET_ALL_CLAIMS_SUCCESS,
  payload: claims,
});

export const declareEmailClaim = (payload) => (dispatch) => {
  const {data} = payload;
  claimEmail(data)
    .then((response) => {
      dispatch(appSuccess);
      toastr.success("INFO", "Votre déclération de sinistre a bien été envoyée.");
    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
    });
};

// Construit un message lisible meme quand le corps de la reponse n'est pas du
// JSON : un 413 renvoye par nginx est une page HTML, donc `data.message` est
// `undefined` et l'ancienne concatenation affichait "undefined. Request failed
// with status code 413".
const claimHttpErrorMessage = (error) => {
  const response = error && error.response;
  const status = response && response.status;

  if (status === 413) {
    return "Pièces jointes trop volumineuses : le serveur a refusé l'envoi. Réduisez la taille ou le nombre de fichiers (20 Mo maximum par fichier).";
  }

  const data = response && response.data;
  if (data && typeof data === "object" && data.message) {
    return data.message + ". " + error.message;
  }
  if (status) {
    return "Le serveur a refusé la déclaration (erreur " + status + ").";
  }
  return "Une erreur est survenue lors de la connexion au serveur";
};

export const declareClaim = (payload) => (dispatch) => {
  const {data} = payload;
  dispatch(appLoading());
  return postClaim(data)
    .then((response) => {
      // Le back repond 200 avec {status: "error"} en cas d'echec applicatif
      // (ex. $_POST vide parce que post_max_size a ete depasse cote PHP).
      if (response && response.data && response.data.status === "error") {
        const applicativeError = new Error(
          response.data.message || "Erreur serveur"
        );
        applicativeError.displayMessage =
          "La déclaration n'a pas pu être enregistrée : " +
          (response.data.message || "erreur serveur") +
          ".";
        throw applicativeError;
      }
      dispatch(appSuccess());
      toastr.success("INFO", "Sinistre déclaré");
      return response;
    })
    .catch((error) => {
      dispatch(appError());
      const message = error.displayMessage || claimHttpErrorMessage(error);
      toastr.error("ERROR", message);
      console.log("Error: ", message);
      throw error;
    });
};

export const getAllClaimForLoginUser = () => (dispatch) => {
  dispatch(appLoading());
  getClaims()
    .then((response) => {
      dispatch(appSuccess());
      dispatch(getClaimsSuccess(response.data.data));
    })
    .catch((error) => {
      dispatch(appError());
      if (error && error.response && error.response.data) {
        toastr.error(
          "ERROR",
          error.response.data.message + ". " + error.message
        );
        console.log(
          "Error: ",
          error.response.data.message + ". " + error.message
        );
      } else {
        toastr.error("ERROR", "Une erreur est survenue lors de la connexion au serveur");
        console.log("Error: ", "error connected to server");
      }
    });
};
